var Mixin = {
	uploadProgress: function () {
		return ((this.state.progress.loaded / this.state.progress.total) * 100) + '%';
	}
};

module.exports = Mixin;
